import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Eye, EyeOff } from 'lucide-react';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error('Email və şifrə daxil edin');
      return;
    }

    setLoading(true);
    try {
      await login(email, password);
      toast.success('Uğurla daxil oldunuz!');
      navigate('/');
    } catch (error) {
      console.error('Login error:', error);
      if (error.code === 'auth/invalid-credential') {
        toast.error('Email və ya şifrə yanlışdır');
      } else if (error.code === 'auth/user-not-found') {
        toast.error('Bu email ilə istifadəçi tapılmadı');
      } else {
        toast.error('Giriş zamanı xəta baş verdi');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-dark flex items-center justify-center px-4 pt-24" data-testid="login-page">
      <div className="w-full max-w-md">
        {/* Form Card */}
        <div className="glass-dark p-8 border border-gray-700 rounded-xl">
          <h1 className="text-2xl font-bold text-white text-center mb-8">
            Giriş
          </h1>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email" className="text-gray-400 font-medium">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@example.com"
                className="mt-2 bg-black/50 border-gray-700 text-white focus:border-red-500"
                data-testid="login-email"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-gray-400 font-medium">Şifrə</Label>
              <div className="relative mt-2">
                <Input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="bg-black/50 border-gray-700 text-white focus:border-red-500 pr-10"
                  data-testid="login-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full btn-primary text-white py-6 rounded-lg font-bold text-lg"
              data-testid="login-submit"
            >
              {loading ? 'Giriş edilir...' : 'Daxil Ol'}
            </Button>
          </form>

          <p className="text-gray-400 text-center mt-6">
            Hesabınız yoxdur?{' '}
            <Link to="/register" className="text-red-400 hover:underline font-semibold">
              Qeydiyyatdan keçin
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
